import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons/faArrowUp";
import "./ScrollToTop.css";

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  const handleScroll = () => {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const docHeight =
      document.documentElement.scrollHeight - window.innerHeight;

    // Mostrar el botón a partir de 300px de scroll
    if (scrollY > 300) {
      setVisible(true);
    } else {
      setVisible(false);
    }

    // Calcular el porcentaje de avance de scroll (0 a 100)
    if (docHeight > 0) {
      const progress = Math.min(
        Math.max((scrollY / docHeight) * 100, 0),
        100
      );
      setScrollProgress(progress);
    } else {
      setScrollProgress(0);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    visible && (
      <button
        className="scroll-to-top"
        onClick={scrollToTop}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            scrollToTop();
          }
        }}
        style={{ "--p": `${scrollProgress.toFixed(1)}%` }}
        aria-label="Subir al inicio de la página"
        title="Subir al inicio"
      >
        <span className="scroll-to-top-inner" aria-hidden="true">
          <FontAwesomeIcon icon={faArrowUp} />
        </span>
      </button>
    )
  );
};

export default ScrollToTop;
